const API_BASE = '/api';

export const signup = async ({ email, password }) => {
  const res = await fetch(`${API_BASE}/auth/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Signup failed');
  }

  return res.json();
};

export const login = async ({ email, password }) => {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Login failed');
  }

  return res.json();
};

export const getMe = async () => {
  const res = await fetch(`${API_BASE}/me`, {
    credentials: 'include',
  });

  if (res.status === 401) return null;
  if (!res.ok) return null;

  return res.json();
};

export const getLikes = async () => {
  const res = await fetch(`${API_BASE}/me/likes`, {
    credentials: 'include',
  });

  if (res.status === 401) return [];
  if (!res.ok) return [];

  return res.json();
};

export const toggleLike = async listingId => {
  const res = await fetch(`${API_BASE}/me/likes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ listingId }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Like failed');
  }

  return res.json();
};

export const logout = async () => {
  const res = await fetch(`${API_BASE}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
    cache: 'no-store',
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Logout failed');
  }

  return res.json();
};